var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',_vm._b({attrs:{"id":"page1"}},'canvas',_vm.canvasAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }